var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5064 71.5285L67.0002 65.0347L73.4939 71.5285L79.0455 65.9766L72.552 59.4828L79.0455 52.9893L73.4939 47.4375L67.0002 53.931L60.5064 47.4375L54.9548 52.9893L61.4483 59.4828L54.9548 65.9766L60.5064 71.5285Z",
    fill: "#425364"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V134H134V0H0ZM126.148 31.2592H74.1379L86.8822 7.85156H126.148V31.2592ZM77.9425 7.85156L65.1983 31.2592H7.85156V7.85156H77.9425ZM7.85156 126.148V39.1107H126.148V126.148H7.85156Z",
    fill: "#425364"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8616 15.6113H25.1599V23.4629H16.8616V15.6113Z",
    fill: "#425364"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8748 15.6113H42.1728V23.4629H33.8748V15.6113Z",
    fill: "#425364"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8875 15.6113H59.1858V23.4629H50.8875V15.6113Z",
    fill: "#425364"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0799 82.7705H30.4314L14.1362 111.169H32.1621L32.1427 119.47L39.9943 119.488L40.0137 111.169H46.6993V103.317H40.032L40.0799 82.7705ZM32.1804 103.317H27.6935L32.1985 95.4662L32.1804 103.317Z",
    fill: "#425364"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.156 82.7705H101.507L85.212 111.169H103.238L103.219 119.47L111.07 119.488L111.09 111.169H117.775V103.317H111.108L111.156 82.7705ZM103.256 103.317H98.7696L103.275 95.4662L103.256 103.317Z",
    fill: "#425364"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 80.6211C59.9821 80.6211 54.2727 86.3305 54.2727 93.3487V107.425C54.2727 114.443 59.9821 120.152 67.0001 120.152C74.0181 120.152 79.7275 114.443 79.7275 107.425V93.3487C79.7275 86.3305 74.0181 80.6211 67.0001 80.6211ZM71.8759 107.425C71.8759 110.113 69.6887 112.301 67.0001 112.301C64.3115 112.301 62.1243 110.114 62.1243 107.425V93.3487C62.1243 90.6601 64.3115 88.4727 67.0001 88.4727C69.6887 88.4727 71.8759 90.6598 71.8759 93.3487V107.425Z",
    fill: "#425364"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.9a5c97f9ec334c925914be59e74a3ec3.svg";
export { ForwardRef as ReactComponent };